import type { Footer, Navigation } from "@servicepro/jobsite-components";
import { footerFromOtherPage, navigationFromOtherPage } from "@servicepro/jobsite-components";
import type { ComponentProps } from "react";

/** The nav and the footer a page renders. */
interface PageChrome {
  navigationConfig?: ComponentProps<typeof Navigation>;
  footerConfig?: ComponentProps<typeof Footer>;
}

/**
 * The site's nav and footer as they work on a page. A one-page site's sections
 * are all on its home page, so on any other page (the 404 page) their section
 * links, such as "#contact", go there as "/#contact". Every other site's are
 * left as they are.
 * @param {object} site The site: whether it is one page, and the nav and footer it saved.
 * @param {boolean} [site.onePage] Whether the whole site is its home page.
 * @param {string} pagePath The page being rendered.
 * @returns {PageChrome} The nav and the footer for that page.
 */
const chromeForPage = (site: { onePage?: boolean } & PageChrome, pagePath: string): PageChrome => {
  const { footerConfig, navigationConfig } = site;
  if (site.onePage !== true || pagePath === "/") {
    return { footerConfig, navigationConfig };
  }
  return {
    footerConfig: footerConfig === undefined ? undefined : footerFromOtherPage(footerConfig),
    navigationConfig: navigationConfig === undefined ? undefined : navigationFromOtherPage(navigationConfig),
  };
};

// The footer comes from here too, so a page reads its whole chrome from one module.
export { SiteFooter } from "./site-footer";
export { chromeForPage };
